import React, { Component } from "react";
import { Grid } from "semantic-ui-react";
import { connect } from "react-redux";
//import CheckBox from "./checkbox";
import languages from "../languages.json";
import { updateInitialData, updateData } from "../actions/actions-data";
import DropDown from "./dropdown";
import InputBox from "./inputbox";

export default connect(
    mapStateToProps,
    { updateInitialData, updateData }
)(
    class VehicleParameters extends Component {
        render() {
            const t = languages[this.props.language];
            const options = [
                { key: "petrol", value: "petrol", text: t.vehicle_parameters.fuel_types.petrol },
                { key: "diesel", value: "diesel", text: t.vehicle_parameters.fuel_types.diesel },
                { key: "hybrid", value: "hybrid", text: t.vehicle_parameters.fuel_types.hybrid },
                // { key: "e85", value: "e85", text: t.vehicle_parameters.fuel_types.e85 },
                // { key: "gpl", value: "gpl", text: t.vehicle_parameters.fuel_types.gpl },
                // { key: "gnv", value: "gnv", text: t.vehicle_parameters.fuel_types.gnv },
                // { key: "ev", value: "ev", text: t.vehicle_parameters.fuel_types.ev },
            ];

            return (
                <Grid style={{ minWidth: "350px" }}>
                    {/* <Grid.Row>
                        <Grid.Column verticalAlign="middle">
                            <CheckBox
                                action={this.props.updateInitialData}
                                secondaryAction={this.props.updateData}
                                label={t.vehicle_parameters.vehicle_type}
                                target="professional_vehicle"
                            />
                        </Grid.Column>
                    </Grid.Row> */}
                    <Grid.Row>
                        <Grid.Column verticalAlign="middle">
                            <DropDown
                                label={t.vehicle_parameters.fuel}
                                action={this.props.updateInitialData}
                                secondaryAction={this.props.updateData}
                                options={options}
                                defaultValue={this.props.parameters.vehicle_fuel}
                                target={"vehicle_fuel"}
                                fluid
                            />
                        </Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                        <Grid.Column verticalAlign="middle">
                            <InputBox
                                action={this.props.updateInitialData}
                                secondaryAction={this.props.updateData}
                                target="raw_initial_price"
                                init={this.props.parameters.raw_initial_price}
                                suffix={t.parameters.money}
                                label={t.vehicle_parameters.base_price}
                                fluid
                            />
                        </Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                        <Grid.Column verticalAlign="middle">
                            <InputBox
                                action={this.props.updateInitialData}
                                secondaryAction={this.props.updateData}
                                target="co2_emissions"
                                init={this.props.parameters.co2_emissions}
                                label={t.vehicle_parameters.co2_emissions}
                                suffix="g/km"
                                fluid
                                integer={true}
                            />
                        </Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                        <Grid.Column verticalAlign="middle">
                            <InputBox
                                action={this.props.updateInitialData}
                                secondaryAction={this.props.updateData}
                                target="cv"
                                init={this.props.parameters.cv}
                                label={t.vehicle_parameters.cv}
                                suffix="CV"
                                fluid
                                integer={true}
                                min={0}
                                max={13}
                            />
                        </Grid.Column>
                    </Grid.Row>

                    <Grid.Row>
                        <Grid.Column verticalAlign="middle">
                            <InputBox
                                action={this.props.updateInitialData}
                                secondaryAction={this.props.updateData}
                                target="vat_level"
                                init={this.props.data.vat_level}
                                label={t.vehicle_parameters.vat_level}
                                suffix="%"
                                disabled={this.props.data.professional_vehicle}
                                fluid
                            />
                        </Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                        <Grid.Column verticalAlign="middle">
                            <InputBox
                                action={this.props.updateInitialData}
                                secondaryAction={this.props.updateData}
                                target="fuel_price"
                                init={this.props.data.fuel_price}
                                label={t.vehicle_parameters.fuel_price}
                                suffix={t.parameters.money}
                                step={0.1}
                                fluid
                                min={0}
                                max={5}
                            />
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            );
        }
    }
);

function mapStateToProps(state) {
    return {
        data: state.reducerData,
        parameters: state.reducerParameters,
        language: state.reducerLanguage,
    };
}



// WEBPACK FOOTER //
// ./src/components/vehicle-parameters.js